import { defineComponent, renderSlot, watch } from 'vue'
import { provideGlobalConfig } from './hooks/use-global-config'
import { configProviderProps } from './config-provider-props'

import type { MessageConfigContext } from '@jdesign-vue/components/message'
// import type { Language } from '@jdesign-vue/locale'

// // 工具函数：更新HTML的internationalization属性
// const updateHtmlLangAttribute = (locale?: Language) => {
//   console.log(123)
//   if (locale?.name && typeof document !== 'undefined') {
//     const normalizedLang = locale.name.toLowerCase().replace('_', '-')
//     const isChineseLocale = ['zh-cn', 'zh-tw'].includes(normalizedLang)
//     // 设置internationalization属性用于CSS字体选择 (true表示非中文，false表示中文)
//     const htmlCollection = document.querySelectorAll('html')
//     const htmlList = [...htmlCollection]
//     if (htmlList && htmlList.length > 0) {
//       htmlList.forEach((html) => {
//         html.setAttribute('jd-internationalization', String(!isChineseLocale))
//       })
//     }
//   }
// }

export const messageConfig: MessageConfigContext = {}
export const loadingConfig: {
  background?: string
  svgColor?: string
  textColor?: string
} = {}
export const drawerConfig: {
  titleSize?: string
} = {}

const ConfigProvider = defineComponent({
  name: 'JdConfigProvider',
  props: configProviderProps,

  setup(props, { slots }) {
    watch(
      () => props.message,
      (val) => {
        Object.assign(messageConfig, val ?? {})
      },
      { immediate: true, deep: true }
    )
    watch(
      () => props.loading,
      (val) => {
        Object.assign(loadingConfig, val ?? {})
      },
      { immediate: true, deep: true }
    )
    watch(
      () => props.drawer,
      (val) => {
        Object.assign(drawerConfig, val ?? {})
      },
      { immediate: true, deep: true }
    )

    // 监听locale变化，动态更新HTML属性
    // watch(
    //   () => props.locale,
    //   (newLocale) => {
    //     updateHtmlLangAttribute(newLocale)
    //   },
    //   { immediate: true, deep: true }
    // )

    const config = provideGlobalConfig(props)
    return () => renderSlot(slots, 'default', { config: config?.value })
  },
})
export type ConfigProviderInstance = InstanceType<typeof ConfigProvider>

export default ConfigProvider
